export const passwordOTP = {
  Back: 'Voltar',
  'We sent a code to {{contact}}': 'Enviamos um código para {{contact}}',
  'Enter the verification code': 'Digite o código de verificação',
  'Resend code at': 'Reenviar código em',
  'Resend code': 'Reenviar código',
  'Change shipping method': 'Alterar método de envio',
  'Code validated successfully!': 'Código validado com sucesso!',
};
